import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { TablerIconsModule } from "angular-tabler-icons";

@Component({
  selector: "app-treeslo-grid-row-details",
  standalone: true,
  imports: [TranslateModule, TablerIconsModule],
  templateUrl: "./treeslo-grid-row-details.component.html",
  styleUrl: "./treeslo-grid-row-details.component.scss",
})
export class TreesloGridRowDetailsComponent {
  @Input() titleKey = "cases.detail.title";
}
